<template>
	<div class="mh-portfolio-modal" id="mh">
		<div class="container">
			<div class="row mh-portfolio-modal-inner">
				<div class="col-sm-5">
					<h2>Wrap - A campanion plugin</h2>
					<p>
						Wrap is a clean and elegant Multipurpose Landing Page Template. It will fit perfectly for Startup, Web App or any type of Web Services. It has 4 background styles with 6 homepage styles. 6 pre-defined color scheme. All variations are organized separately so you can use / customize the template very easily.
					</p>

					<p>
						It is a clean and elegant Multipurpose Landing Page Template. It will fit perfectly for Startup, Web App or any type of Web Services. It has 4 background styles with 6 homepage styles. 6 pre-defined color scheme. All variations are organized separately so you can use / customize the template very easily.
					</p>
					<div class="mh-about-tag">
						<ul>
							<li>
								<span>php</span>
							</li>
							<li>
								<span>html</span>
							</li>
							<li>
								<span>css</span>
							</li>
							<li>
								<span>php</span>
							</li>
							<li>
								<span>wordpress</span>
							</li>
							<li>
								<span>React</span>
							</li>
							<li>
								<span>Javascript</span>
							</li>
						</ul>
					</div>
					<a href="#" class="btn btn-fill">Live Demo</a>
				</div>
				<div class="col-sm-7">
					<div class="mh-portfolio-modal-img">
						<lazy-image source="/images/portfolio/portfolio-light.gif" alt class="img-fluid" />
						<p>
							All variations are organized separately so you can use / customize the template very easily.
						</p>
						<img />
						<lazy-image source="/images/portfolio/shots/vmax-splash.png" alt class="img-fluid" />
						<p>
							All variations are organized separately so you can use / customize the template very easily.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		stack: {
			type: Object,
			required: true,
			default: () => {}
		}
	}
};
</script>
